export default {
  //German de(languagecode) DE(countrycode) Deutschland / Deutsch
  LandingPage: {
    intro_sub:
      'Nicht jede Verpackung gehört in den Abfall. Schütze die Umwelt und verwandle deine Verpackung in einen nützlichen Gegenstand.',
    title: 'Samsung Upcycle-Verpackung',
    sequence1_1: 'Hilf uns dabei, die Umwelt zu schützen',
    sequence1_2:
      'und verwandle deine Produkt-verpackung in einen nützlichen Alltagsgegenstand. Scrolle weiter nach unten und entdecke, wie du dir und der Umwelt einen Gefallen tun kannst. ',
    sequence2_1: 'Die neue Samsung Upcycle-Verpackung',
    sequence2_2:
      'Mit unserer speziell gefertigten Produkt-Verpackung, kannst du zum Wohl der Umwelt beitragen, indem du sie einfach in einen nützlichen Gegenstand für den Haushalt verwandelst. ',
    sequence3_1: 'Folge den aufgedruckten Punkten auf deiner Verpackung',
    sequence3_2:
      'Schneide deine Verpackung nach den Vorgaben aus und erschaffe neue Gegenstände.',
    sequence4_1: 'Wähle den Gegenstand aus, den du herstellen möchtest',
    sequence4_2:
      'Scrolle nach unten und wähle das Produkt-Modell, das du auf deiner Verpackung findest. Entscheide dich dann für eine der verschiedenen Gestaltungsmöglichkeiten und erschaffe etwas Neues, an dem du täglich Freude haben kannst.',
    selectBox: 'Wähle deinen produkt',
    moreActivity:
      "Hier findest du mehr Informationen zu Nachhaltigkeit von Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace\n Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/de/sustainability/overview/',
    moreActivityLink: 'https://www.samsung.com/de/sustainability/overview/',
    footer: `
    Copyright© 2019-2021 Samsung. Alle Rechte vorbehalten.`,
  },
  ProductPage: {
    selectDesign: 'Wähle ein Design deiner Wahl aus',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV-Konsole',
    StorageBox: 'Aufbewahrungsbox',
    MagazineRack: 'Zeitschriftenhalter',
    CatHouse: 'Katzenhaus',
    CatTunnel: 'Katzentunnel',
    BookShelf: 'Bücherregal',
    DeskShelf: 'Schreibtischregal',
    BlackRhino: 'Bedrohte Tierart \n Spitzmaulnashorn', //update
    PolarBear: 'Bedrohte Tierart \n Polarbär', //update
    SeaTurtle: 'Bedrohte Tierart \n Meeresschildkröte', //update
    TheRider: 'Schaukelpferd', //update
    Kibe: 'Regaltreppe', //update
    Tessellate: 'Nachttisch', //update
    Twist: 'Aufbewahrungsbox', //update
    AlexCouchArmTable: 'Alex \n Sofa-Tablett', //update
    BlastOffClubHouse: 'Clubhaus', //update
    KinokoTable: 'Kinoko Tisch', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postkartenhalter', //update
    SneakerRack: 'Schuhregal', //update
    TheSoban: 'Beistelltisch', //update
    ToolBox: 'Werkzeugkasten', //update
    DeskStationary: 'Schreibwaren',
    CoinBank: 'Spardose',
    MobileScanner:'Smartphone-Scanner-Halterung',
    TabletScanner:'Tablet-Scanner-Halterung',
    PetStairs:'Haustiertreppe',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'Minuten',
    all:'ALL',
    in: 'in',
    inOnly: 'in nur',
    allBoxSize: 'Alle Verpackungsgrößen',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'Anleitung',
    prepare: 'Bereite die Verpackung vor',
    LetsDesign: "Lege los",
    drawParts: 'Zeichne Teile auf der Verpackung ein',
    note1: 'Beachte, dass die Position der Grafik je nach Land und Größe variieren kann.',
    note2: 'Skizziere zuerst die gesamte Zeichnung, damit sie auf die Verpackung passt.',
    numberSpace: 'Nummer = Abstand zwischen den Punkten',
    diagonal: 'diagonal',
    LEFT: 'LINKS (Teil)',
    RIGHT: 'RECHTS (Teil)',
    TOP: 'OBEN (Teil)',
    TOP1: 'OBEN (Teil) 1',
    TOP2: 'OBEN (Teil) 2',
    BACK: 'RÜCKSEITE (Teil)',
    MIDDLE: 'MITTE (Teil)',
    MIDDLE2: 'MITTE (Teil) 2',
    BOTTOM: 'UNTEN(Teil)',
    FRONT: 'VORDERSEITE (Teil)',
    SIDE: 'SEITE (Teil)',
    secondSIDE: 'ZWEITE SEITE (Teil)',
    secondSIDE1: 'ZWEITE SEITE (Teil) 1',
    secondSIDE2: 'ZWEITE SEITE (Teil) 2',
    LEG: 'FUSS (Teil)', //update
    JOINT: 'GELENK (Teil)', //update
    FACE: 'GESICHT (Teil)', //update
    DRAWERBOTTOM: 'SCHUBLADENBODEN (Teil)', //update
    DRAWERSIDE: 'SCHUBLADENSEITE (Teil)', //update
    NOSE: 'NASE (Teil)', //update
    HANDLE: 'GRIFF (Teil)', //update
    BOTTOMSIDE: 'UNTERE SEITE (Teil)', //update
    TOPSIDE: 'OBERSEITE (Teil)', //update
    WING: 'FLÜGEL (Teil)', //update
    cutAndAssemble: "Ausschneiden & Zusammensetzen",
    beCareful: 'Achte darauf, dich bei der Verwendung des Messers nicht zu verletzen',
    cutOutParts: 'Schneide die Teile aus',
    assemble: 'Zusammensetzen',
    Assemblyguide: 'Anleitung zum Zusammensetzen', //update
    fold: 'Faltbeispiel',
    foldGuide: 'Nutze die Kanten von Möbeln, um den Karton leichter zu falten',
    foldGuideDezeen:
      'Drücke mit einem Rillwerkzeug einige Male auf die gestrichelte Linie auf dem Karton, damit er sich leichter falten lässt.', //update
    glue: 'Trage Kleber oder Klebeband gleichmäßig auf die Oberfläche auf', //update
    cable: 'Verwende Kabelbinder oder Schnüre zum Verbinden', //update
    done: 'Fertig!',
    goBack: 'Zurück zum Hauptmenü',
  },
  CautionPage: {
    CAUTION: 'ACHTUNG',
    needItem: 'Du benötigst folgende Gegenstände',
    children: 'Kinder sollten in Begleitung von Erwachsenen sein',
    mat:
      'Bitte lege eine Abdeckung auf den Boden, um Kratzer zu vermeiden',
    doNotPutHeavyThing:
      'Achte darauf, nicht auf die Möbel zu treten und dich nicht darauf zu setzen und versuche nicht, schwere Dinge darauf abzustellen',
    doNotThrow:
      'Wirf die Möbel nicht in die Richtung von Menschen oder Tieren',
    stayAwayFlame: 'Halte die Möbel von offenen Flammen fern',
    stayAwayWater: 'Bringe die Möbel nicht in die Nähe von Wasser oder Feuchtigkeit ',
    mayDamaged: '* Die TV-Box kann während des Transportes beschädigt werden',
    companyDoestResponsible:
      '* Das Unternehmen trägt keine Verantwortung für Pannen oder Verletzungen während des Zussammensetzens dieser Möbel',
    cannotBeReturned:
      '* Ein beschädigter Karton kann nicht zurückgegeben werden, weil er nicht den Qualitätsanforderungen entspricht.',
    understand: 'Alles klar, ich verstehe',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Wir haben für die meisten unserer TV-Verpackungen im Vergleich zu unseren früheren Verpackungen weniger Papier und Tinte verwendet, um unser Engagement für Nachhaltigkeit zu verstärken',
      text2:'',
      text2_special:
        '(* Das oben Genannte gilt nicht für bestimmte Modelle, einschließlich Lifestyle-Fernseher)',
      text3: 'Wähle die Schaltflächen unten, um mehr zu erfahren',
    },
    greenIn: {
      title: 'Umweltbewusste TV-Verpackung',
      subtitle1: 'Suche nach Produktinformationen',
      subtitle2: 'Upcycling Eco-Verpackung',
      desc: 'Suche den Modellnamen, um weitere Informationen zu erhalten',
      descM: '* Foto von der TV-Modellnummer machen',
      guide: 'Modellname',
      button: 'Foto aufnehmen',
      button2: 'Gehe zu Gegenstand erstellen',
      product_info: 'Produktinformationen',
    },
    search: {
      guide: 'Suche..',
      noResult: 'Kein Ergebnis',
      more: 'MEHR',
      search: 'Suche',
      retake: 'Wiederaufnahme',
      result: 'Ergebnis',
    },
    photo: {
      guide1: 'Gib den Namen des TV-Modells in das Feld ein',
      guide2: '(z.B. Q800A, UT7000, RU7100, etc)',
    },
  },
  searchCountrySelect: 'Wähle ein Land für die Suche'
};
